import React from 'react';
import { PartnersListIndexContainer } from '@/modules/Partners';

const PartnersList = (): JSX.Element => <PartnersListIndexContainer />;

export default PartnersList;
